import Block from "components/layout/block";
import { ListSnapshot } from "models/list-snapshot";
import { useEffect, useState } from "react";
import { useList } from "stores/hooks/list";
import LogTable from "./log-table";
import { adminDoGetListSnapshots } from "services/admin/list-snapshot";
//import { diff } from "json-diff";

const LogTab = () => {
  const list = useList();
  const [listSnapshots, toggleListSnapshots] = useState<ListSnapshot[]>([]);

  useEffect(() => {
    const fetch = async () => {
      if (list) {
        // get raw list of snapshots
        const snapshots = await adminDoGetListSnapshots(list.uuid);

        /*         // create changelog
        for (let i = snapshots.length - 1; i >= 0; i -= 1) {
          const current = snapshots[i];
          const previous = snapshots[i + 1];

          // if there are previous entry, calculate change
          current.changes = diff(previous, current || {}, {
            full: false,
            outputNewOnly: true,
            verbose: false,
            raw: true,
          });
        }
 */
        // store to state
        toggleListSnapshots(snapshots);
      }
    };
    fetch();
  }, [list?.uuid]);

  if (!list) {
    return null;
  }

  return (
    <Block title="Loki">
      <LogTable listUuid={list.uuid} listSnapshots={listSnapshots} />
    </Block>
  );
};

export default LogTab;
